module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_13.d29b5467.png";